// extracted by mini-css-extract-plugin
export default {"loading":"ConfirmationInnerLoader-module__loading___rPfqf"};